import { AlertModalEditFormComponent } from '../alert-modal-edit-form/alert-modal-edit-form.component';
import { AlertsService } from 'src/app/core/services/utelize/system/alert/alerts-service';
import { AlertSummaryDTO } from 'src/app/core/models/system/alert/alert-summary-dto';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfigSystemParams, OurColors } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { CompletedModalFormComponent } from '../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfirmationModalFormComponent } from "../_pop-ups/confirmation-modal-form/confirmation-modal-form.component";
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { InformationModalFormComponent } from '../_pop-ups/information-modal-form/information-modal-form.component';
import { LocationWebhookModalFormComponent } from '../location-webhook-modal-form/location-webhook-modal-form.component';
import { NgbModal, NgbModalRef, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-alerts-modal-form',
  templateUrl: './alerts-modal-form.component.html',
  styleUrls: ['./alerts-modal-form.component.scss']
})
export class AlertsModalFormComponent implements OnInit {

  @Input() companyId?                   : number;
  @Input() deviceId?                    : number;
  @Input() featureEnabledCountryPlans   : boolean = false;
  @Input() featureEnabledLocationWebhook: boolean = false;
  @Input() isCompany                    : boolean = true;
  @Input() newCompany                   : boolean = false;

  @Output() alertDataHasBeenSaved: EventEmitter<any>     = new EventEmitter<any>();
  @Output() alertGroupChanged    : EventEmitter<number>  = new EventEmitter<number>();

  @ViewChild('alertModalForm',             { static: false }) alertModalForm!          : AlertModalEditFormComponent;
  @ViewChild('ArrowNgbNav'                                  ) arrowNav!                : NgbNav;
  @ViewChild('completedModalForm',         { static: false }) completedModalForm!      : CompletedModalFormComponent;
  @ViewChild('deleteConfirmationModal',    { static: false }) deleteConfirmationModal! : ConfirmationModalFormComponent;
  @ViewChild('informationModalForm',       { static: false }) informationModalForm!    : InformationModalFormComponent;
  @ViewChild('locationWebhookModalForm',   { static: false }) locationWebhookModalForm!: LocationWebhookModalFormComponent;
  @ViewChild('optOutConfirmationModal',    { static: false }) optOutConfirmationModal! : ConfirmationModalFormComponent;
  @ViewChild('toggleConfirmationModal',    { static: false }) toggleConfirmationModal! : ConfirmationModalFormComponent;
  @ViewChild('warningModalForm'          , { static: false }) warningModalForm!        : WarningModalFormComponent;

  get showLocationWebhook() { return this.isCompany && this.featureEnabledLocationWebhook; }
  get modalBackGround    () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                              return value = value.toUpperCase() == "STATIC" ? "static" : (value.toUpperCase() == "TRUE" ? true : false); }

  get enableAlertsOnNew() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCompanyEnableAlertsOnNew, false); }
  get showTooltips     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTooltips,                 false); }
  
  public navItemLog_Usage   : number=1;
  public navItemLog_Country : number=2;

  public activeId           : number=this.navItemLog_Usage;
  public addAlertToolTipText: string = "Add Usage Alert";
  public maxActionPxLength  : number =152; 
  public alertFormIsOpen    : boolean= false;
  public alerts             : AlertSummaryDTO[] = [];
  public alertToggleAction  : string = "";
  public curUser            : SystemUserDTO;
  public deleteInProgress   : boolean= false;
  public error              : string ="No alerts found.";
  public formTitle          : string ='Alerts';
  public optOutInProgress   : boolean= false;
  public selectedAlertId    : number = -1;
  public toggleInProgress   : boolean= false;
  public warningMessageMain : string | undefined;
  public warningMessageSub  : string | undefined;

  constructor(
    private alertsService        : AlertsService,
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.refresh();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public alertClosed() {
    try {       
      this.alertFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public addAlert() {
    if (this.newCompany && !this.enableAlertsOnNew) {
      this.informationModalForm.openForm("Information", "Please save the company details before adding alerts");
    } else {
      this.alertModalForm.openForm(-1, this.companyId ?? -1, 0, this.activeId);
    }
  }

  public addWebhook() {
    try {
      if (this.newCompany) {
        this.informationModalForm.openForm("Information", "Please save the company details before adding a webhook endpoint");
      } else {
        this.locationWebhookModalForm.openForm(this.companyId ?? -1);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public alertSaved() {
    try {       
      this.alertFormIsOpen=false;

      this.refresh();
      this.alertDataHasBeenSaved.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }

  public deleteAlert(alertId: number | undefined): void {
    try {       
      this.confirmDelete(alertId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public disableAlert(alertId: number | undefined): void {
    try {       
       this.confirmAlertToggle(alertId,false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public enableAlert(alertId: number | undefined): void {
    try {       
       this.confirmAlertToggle(alertId,true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public editAlert(alertId: number | undefined): void {
    try {       
      if (!this.alertFormIsOpen) {       
        this.alertFormIsOpen=true;
        this.alertModalForm.openForm(alertId ?? -1, this.companyId ?? -1, -1, this.activeId);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public optOutAlert(alertId: number | undefined): void {
    try {       
       this.confirmOptOut(alertId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public confirmAlertToggle(alertId: number | undefined, active: boolean) {
    try {
      this.selectedAlertId  = alertId ?? -1;
      let alert             = this.alerts.find(x => x.id == (alertId?? -1));
      let alertName         = alert == undefined ? "" : alert.name;
      this.alertToggleAction= active == true ? "enable" : "disable";

      if (alertId==undefined) {
        throw new Error("AlertsModalFormComponent..SureSIM Alert cannot be determined");
      }

      this.toggleConfirmationModal.openForm("WARNING",
                                            `Are you sure you want to ${this.alertToggleAction} alert ${alertName}?`,
                                            undefined,
                                            OurColors.Red,
                                            OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public confirmDelete(alertId: number | undefined) {
    try {
      this.selectedAlertId = alertId ?? -1;
      let alert            = this.alerts.find(x => x.id == (alertId?? -1));
      let alertName        = alert == undefined ? "" : alert.name;

      if (alertId==undefined) {
        throw new Error("AlertsModalFormComponent..SureSIM Alert cannot be determined");
      }

      this.deleteConfirmationModal.openForm("WARNING",
                                               `Are you sure you want to delete alert ${alertName}?`,
                                               undefined,
                                               OurColors.Red,
                                               OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public confirmOptOut(alertId: number | undefined) {
    try {
      this.selectedAlertId = alertId ?? -1;
      let alert            = this.alerts.find(x => x.id == (alertId?? -1));
      let alertName        = alert == undefined ? "" : alert.name;

      if (alertId==undefined) {
        throw new Error("AlertsModalFormComponent..SureSIM Alert cannot be determined");
      }

      this.optOutConfirmationModal.openForm("WARNING",
                                               `Are you sure you want to opt out from alert ${alertName}?`,
                                               undefined,
                                               OurColors.Red,
                                               OurColors.DarkBlue);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private deleteProcessComplete(alertId : number, companyId : number) {
    try {
      let alert     = this.alerts.find(x => x.id == (this.selectedAlertId?? -1));
      let alertName = alert == undefined ? "" : alert.name;

      var message   = `Alert ${alertName} has been deleted`;

      this.alertDataHasBeenSaved.emit();
      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private optOutProcessComplete(alertId : number, companyId : number) {
    try {
      let alert     = this.alerts.find(x => x.id == (this.selectedAlertId?? -1));
      let alertName = alert == undefined ? "" : alert.name;

      var message   = `This sim has been opted out from Alert ${alertName}`;

      this.alertDataHasBeenSaved.emit();
      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private toggleProcessComplete(alertId : number, companyId : number) {
    try {
      let alert     = this.alerts.find(x => x.id == (this.selectedAlertId?? -1));
      let alertName = alert == undefined ? "" : alert.name;

      var message   = `Alert ${alertName} has been ${this.alertToggleAction}d`;

      this.alertDataHasBeenSaved.emit();
      this.completedModalForm.openForm("Congratulations", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public alertAccent(alert: AlertSummaryDTO): string {
    try {
      if (!this.isCompany)
        return alert.optOut ? 'danger' : 'success';

      if (alert.defaultTemplate)
        return 'warning';

      if (alert.addOnCompanyCreation)
        return 'info';

      return alert.active ? 'success' : 'danger';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'primary';
    }
  }

  public getTextWidth(text: string, font: string = '16px Arial'): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = font;
      let result = context.measureText(text).width;
      // console.log("width",result,text);
      return result;
    }
    return 0;
  }

  public yesDeleteAlert() {
    try {
      this.deleteInProgress = true;
    
      this.alertsService.deleteAlert(this.selectedAlertId, this.companyId ?? -1)
      .pipe(
        catchError((error) => {
          this.deleteInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.deleteInProgress = false;
   
          this.refresh();

          this.deleteProcessComplete(this.selectedAlertId, this.companyId ?? -1);
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.deleteInProgress = false;

            this.warningMessageMain="Delete failed";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.deleteInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesOptOutAlert() {
    try {
      this.optOutInProgress = true;
    
      this.alertsService.optOutAlert(this.selectedAlertId, this.companyId ?? -1, this.deviceId ?? -1, this.curUser.userId)
      .pipe(
        catchError((error) => {
          this.deleteInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.optOutInProgress = false;
   
          this.refresh();

          this.optOutProcessComplete(this.selectedAlertId, this.companyId ?? -1);
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.deleteInProgress = false;

            this.warningMessageMain="Opt out failed";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.deleteInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public yesToggleAlert() {
    try {
      this.toggleInProgress = true;
    
      this.alertsService.toggleAlert(this.selectedAlertId, this.companyId ?? -1)
      .pipe(
        catchError((error) => {
          this.toggleInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.toggleInProgress = false;
   
          this.refresh();

          this.toggleProcessComplete(this.selectedAlertId, this.companyId ?? -1);
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.toggleInProgress = false;

            this.warningMessageMain="Active state change failed";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.toggleInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTabChange(event: any) {
    try {
      this.alertGroupChanged.emit(event.nextId);
      this.addAlertToolTipText = 'Add ' + ((event.nextId == 1) ? 'Usage' : 'Country') + ' alert';
      this.refresh(event.nextId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refresh(TabId:number = this.activeId)
  {    
    try {
      if(this.isCompany){
        if(this.companyId != null) {
          this.alertsService.getCompanyAlerts(this.companyId!, TabId).subscribe(x => this.alerts = x);
        }
      }
      else{
        if(this.companyId != null && this.deviceId != null) {
          this.alertsService.getDeviceAlerts(this.companyId!, this.deviceId!).subscribe({
            next: data => {  
              this.alerts = data;
            },
            error: error => {
            }
          });
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    } 
  }
}
